export default "__VITE_ASSET__62184555__"